module.exports = __webpack_public_path__ + "static/img/title-expert.4530a07b.png";